import Axios from 'axios'

const withAuth = Axios.create({
  credentials: 'same-origin',
  crossdomain: true,
  mode: 'no-cors',
})

const cwsBack = Axios.create({
  credentials: 'same-origin',
  crossdomain: true,
  mode: 'no-cors',
})

// Add a request interceptor
withAuth.interceptors.request.use(
  (config) => {
    let tokenData = ''
    /*
    if (config.region) {
      tokenData = localStorage.getItem(`auth_${config.region}`)
    } else {
      tokenData = localStorage.getItem('cross_region_auth')
    } */
    tokenData = localStorage.getItem('cross_region_auth')
    if (tokenData) {
      tokenData = JSON.parse(tokenData)
      config.headers['x-token'] = tokenData.token
    }
    return config
  },
  (error) => {
    console.log('req error', error)
    // Do something with request error
    return Promise.reject(error)
  },
)
// Add a request interceptor
cwsBack.interceptors.request.use(
  (config) => {
    // let tokenData = localStorage.getItem('cross_region_auth')
    // if (tokenData) {
    //   tokenData = JSON.parse(tokenData)
    //   config.headers['x-token'] = tokenData.token
    // }
    return config
  },
  (error) => {
    console.log('req error', error)
    // Do something with request error
    return Promise.reject(error)
  },
)

export default {
  withAuth,
  cwsBack,
}
